
import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ChatInterface } from "@/components/analytics/chat-interface";
import { DynamicCharts } from "@/components/analytics/dynamic-charts";
import { KPIDashboard } from "@/components/analytics/kpi-dashboard";
import { FinancialAnalytics } from "@/components/analytics/financial-analytics";

export default function PerkPointAnalytics() {
  const [activeChart, setActiveChart] = useState<{ type: string; query: string } | null>(null);

  const handleChartRequest = (chartType: string, query: string) => {
    setActiveChart({ type: chartType, query });
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Analytics Dashboard</h1>
        <p className="text-muted-foreground">
          Comprehensive program analytics and financial insights.
        </p>
      </div>

      <Tabs defaultValue="dashboard" className="w-full">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="dashboard">KPI Dashboard</TabsTrigger>
          <TabsTrigger value="financial">Financial Analytics</TabsTrigger>
          <TabsTrigger value="chat">Natural Language Insights</TabsTrigger>
          <TabsTrigger value="charts">Interactive Charts</TabsTrigger>
        </TabsList>
        
        <TabsContent value="dashboard" className="space-y-6">
          <KPIDashboard />
        </TabsContent>

        <TabsContent value="financial" className="space-y-6">
          <FinancialAnalytics />
        </TabsContent>
        
        <TabsContent value="chat" className="space-y-6">
          <div className="grid gap-6 lg:grid-cols-2">
            <ChatInterface onChartRequest={handleChartRequest} />
            {activeChart && (
              <DynamicCharts 
                chartType={activeChart.type} 
                query={activeChart.query} 
              />
            )}
          </div>
        </TabsContent>
        
        <TabsContent value="charts" className="space-y-6">
          <div className="grid gap-6">
            <div className="grid gap-4 md:grid-cols-2">
              <DynamicCharts chartType="roi-trend" query="Show ROI trends over time" />
              <DynamicCharts chartType="campaign-performance" query="Campaign performance analysis" />
            </div>
            <div className="grid gap-4 md:grid-cols-2">
              <DynamicCharts chartType="enrollment-trends" query="Member enrollment trends" />
              <DynamicCharts chartType="redemption-trends" query="Points redemption analysis" />
            </div>
            <DynamicCharts chartType="cost-breakdown" query="Program cost breakdown" />
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
